import React from 'react';
import { BoardLimitHeaderBlock } from '../../account/PlanStateHeaderBlock';
import { ConfettiLayer } from '../../canvas/ConfettiLayer';
import { EditorPalette } from '../../canvas/EditorPalette';
import { PointerHandler } from '../../canvas/PointerHandler';
import { KioskScope } from '../../canvas/kiosk/KioskScope';
import { OverlayLayer } from '../../canvas/overlay/OverlayLayer';
import { ShareHeaderBlock } from '../../canvas/participants/ShareButton';
import { CaptureWheel, ToolLayer } from '../../canvas/tooling/ToolLayer';
import { TransformLayer } from '../../canvas/tooling/transform/TransformLayer';
import { CanvasView } from '../../canvas/ui/CanvasView';
import { HtmlRenderer } from '../../canvas/visualization/HtmlRenderer';
import { MeetingHeaderView } from '../../canvas/workflow/MeetingHeaderView';
import { PasteSupport } from '../../canvas/workspace/PasteSupport';
import { AdapterLayer } from '../../canvas/workspace/adapters/AdapterLayer';
import { PawnLayer } from '../../canvas/workspace/participants/PawnLayer';
import { WidgetLayer } from '../../canvas/workspace/widgets/WidgetLayer';
import { Page } from '../../common/Page';
import { HelpButton } from '../../help/HelpButton';
import { AlertLayer } from '../../packages/alerts/AlertLayer';
import { HandLayer } from '../../packages/hand/HandLayer';
import { HatLayer } from '../../packages/hats/HatLayer';
import { LowerPresentLayer } from '../../packages/presentation/LowerPresentLayer';
import { UpperPresentLayer } from '../../packages/presentation/UpperPresentLayer';
import { ToastLayer } from '../../packages/toast/ToastLayer';
import { PreferencesButton } from '../../preferences/PreferencesButton';
import { ProgressProvider } from './ProgressContext';
import { TutorialPackage } from './TutorialPackage';

export const BasicTutorialPage = () => {

    return <ProgressProvider>
        <Page>
            <KioskScope packages={[TutorialPackage]}>
                <Page.Header divide="hover">
                    <Page.HeaderCenter>
                        <MeetingHeaderView />
                        <BoardLimitHeaderBlock />
                    </Page.HeaderCenter>
                    <Page.HeaderPush>
                        {/* <TutorialProgressBar /> */}
                        <ShareHeaderBlock />
                        <Page.HeaderBlock data-tour="header-help">
                            <PreferencesButton />
                            <HelpButton />
                        </Page.HeaderBlock>
                    </Page.HeaderPush>
                </Page.Header>
                <Page.Content flush>
                    <CanvasView>
                        <HtmlRenderer />
                        <PointerHandler />
                        <CaptureWheel>
                            <ToolLayer />
                        </CaptureWheel>
                        <HandLayer />
                        <OverlayLayer />
                        <ConfettiLayer />
                        <PawnLayer />
                        <HatLayer />
                        <LowerPresentLayer />
                        <TransformLayer />
                        <CaptureWheel>
                            <AdapterLayer />
                            <WidgetLayer />
                        </CaptureWheel>
                        <AlertLayer />
                        <ToastLayer />
                        <PasteSupport />
                        <EditorPalette />
                    </CanvasView>
                </Page.Content>
                <UpperPresentLayer />
            </KioskScope>
        </Page>
    </ProgressProvider>;
};
